export default __webpack_public_path__ + "static/media/Approved.9e93205a.svg";